import { cn } from "@/v5/lib/utils";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface CollapseChevronProps {
  collapsed: boolean;
  onClick: () => void;
  side: "left" | "right";
  className?: string;
  title?: string;
}

export function CollapseChevron({
  collapsed,
  onClick,
  side,
  className,
  title,
}: CollapseChevronProps) {
  const Icon = side === "left"
    ? (collapsed ? ChevronRight : ChevronLeft)
    : (collapsed ? ChevronLeft : ChevronRight);

  return (
    <button
      onClick={onClick}
      className={cn(
        "absolute top-3 z-30 flex h-6 w-6 items-center justify-center rounded-full border border-border bg-background text-muted-foreground shadow-sm hover:bg-accent hover:text-foreground transition-colors",
        side === "left" ? "-right-3" : "-left-3",
        className,
      )}
      title={title ?? (collapsed ? "Expand" : "Collapse")}
    >
      <Icon className="h-3.5 w-3.5" />
    </button>
  );
}
